import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import zh from "./locales/zh.json";
import de from "./locales/de.json";
import vi from "./locales/vi.json";
import th from "./locales/th.json";
import id from "./locales/id.json";
import ms from "./locales/ms.json";

// 获取保存的语言设置或浏览器语言
const getBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  const shortLang = browserLang.split("-")[0]; // 例如 'zh-CN' -> 'zh'

  // 检查是否支持该语言
  return ["en", "zh", "de", "vi", "th", "id", "ms"].includes(shortLang)
    ? shortLang
    : "en";
};

// 获取保存的语言或使用浏览器语言
const savedLocale = localStorage.getItem("locale") || getBrowserLanguage();

// 语言包
const messages = {
  en,
  zh,
  de,
  vi,
  th,
  id,
  ms,
};

// 创建i18n实例
const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: savedLocale,
  fallbackLocale: "en",
  messages,
});

export default i18n;
//   messages,
// });

// export default i18n;
